import { isNullOrEmpty } from "./isNullOrEmpty";
export class ValidationResult {
    constructor(validationType) {
        this.validationType = '';
        this.hasError = false;
        this.errorMessage = '';
        this.value = null;
        this.expectedValue = null;
        this.validationType = validationType || '';
    }
    static createError(errorMessage) {
        const result = new ValidationResult();
        result.hasError = true;
        result.errorMessage = errorMessage;
        return result;
    }
    static createSuccess() {
        const result = new ValidationResult();
        return result;
    }
}
export const validator = {
    required: function requiredValidator(value) {
        value = value || true;
        return function requiredValidator(formValue) {
            var response = new ValidationResult('validator.required');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'boolean') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if (expectedValue === true && (formValue == null || formValue.toString().length === 0)) {
                response.hasError = true;
                response.errorMessage = 'Campo requerido';
            }
            return response;
        };
    },
    maxLength: function maxLengthValidator(value, customMessageError) {
        return function maxLengthValidator(formValue) {
            var response = new ValidationResult('validator.maxLength');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'number') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
            }
            if (expectedValue > 0) {
                var lenght = 0;
                if (formValue == null) {
                    formValue = 0;
                }
                else if (typeof (formValue) === 'string') {
                    lenght = formValue.toString().length;
                }
                else if (typeof (formValue) === 'number') {
                    lenght = formValue.toString().length;
                }
                response.expectedValue = expectedValue;
                response.value = lenght;
                if (lenght > expectedValue) {
                    response.hasError = true;
                    response.errorMessage = customMessageError ?
                        typeof customMessageError === 'function' ? customMessageError() :
                            customMessageError : `Se permite máximo ${expectedValue} caracteres.`;
                }
            }
            return response;
        };
    },
    minLength: function minLengthValidator(value, customMessageError) {
        return function minLengthValidator(formValue) {
            var response = new ValidationResult('validator.minLength');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'number') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.minLength" no es valido.');
            }
            if (expectedValue > 0) {
                var lenght = 0;
                if (formValue == null) {
                    formValue = 0;
                }
                else if (typeof (formValue) === 'string') {
                    lenght = formValue.toString().length;
                }
                else if (typeof (formValue) === 'number') {
                    lenght = formValue.toString().length;
                }
                else if (typeof (formValue) === 'object' && formValue instanceof Array) {
                    lenght = formValue.length;
                }
                response.expectedValue = expectedValue;
                response.value = lenght;
                if (lenght < expectedValue) {
                    response.hasError = true;
                    response.errorMessage = customMessageError ?
                        typeof customMessageError === 'function' ? customMessageError() :
                            customMessageError : `Se requiere como minimo ${expectedValue} caracteres.`;
                }
            }
            return response;
        };
    },
    maxValue: function maxValueValidator(value, customMessageError) {
        return function maxValueValidator(formValue) {
            var response = new ValidationResult('validator.maxValue');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'number') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.maxLength" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if (formValue > expectedValue) {
                response.hasError = true;
                response.errorMessage = customMessageError ?
                    typeof customMessageError === 'function' ? customMessageError() :
                        customMessageError : `El valor máximo permitido es ${expectedValue}`;
            }
            return response;
        };
    },
    minValue: function minValueValidator(value, customMessageError) {
        return function minValueValidator(formValue) {
            var response = new ValidationResult('validator.minValue');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'number') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.minValue" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if (formValue < expectedValue) {
                response.hasError = true;
                response.errorMessage = customMessageError ?
                    typeof customMessageError === 'function' ? customMessageError() :
                        customMessageError : `El valor minimo permitido es ${expectedValue}`;
            }
            return response;
        };
    },
    invalid: function invalidValueValidator(value, errorMessage) {
        return function invalidValueValidator(formValue) {
            var response = new ValidationResult('validator.invalid');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'number') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.invalid" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if ((Number(formValue) || 0) == expectedValue) {
                response.hasError = true;
                response.errorMessage = errorMessage;
            }
            return response;
        };
    },
    custom: function customValidator(callback) {
        return function customValidator(formValue) {
            return callback(formValue);
        };
    },
    maxDate: function maxDateValidator(value, customMessageError) {
        return function maxDateValidator(formValue) {
            var response = new ValidationResult('validator.maxDate');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'object') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.maxDate" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if (formValue > expectedValue) {
                response.hasError = true;
                response.errorMessage = customMessageError ?
                    typeof customMessageError === 'function' ? customMessageError() :
                        customMessageError : `la fecha máxima permitida es ${expectedValue}.`;
            }
            return response;
        };
    },
    minDate: function minDateValidator(value, customMessageError) {
        return function minDateValidator(formValue) {
            var response = new ValidationResult('validator.minDate');
            var expectedValue = null;
            if (typeof (value) === 'function') {
                expectedValue = value();
            }
            else if (typeof (value) === 'object') {
                expectedValue = value;
            }
            else {
                throw new Error('El valor establecido para la regla de validación "validator.minDate" no es valido.');
            }
            response.expectedValue = expectedValue;
            response.value = formValue;
            if (formValue < expectedValue) {
                response.hasError = true;
                response.errorMessage = customMessageError ?
                    typeof customMessageError === 'function' ? customMessageError() :
                        customMessageError : `la fecha mínima permitida es ${expectedValue}.`;
            }
            return response;
        };
    },
    email: function emailValidator(errorMessage) {
        return function emailValidator(formValue) {
            const response = new ValidationResult('validator.email');
            if (!isNullOrEmpty(formValue)) {
                formValue = formValue.replace(',', ';');
                let emails = formValue.split(';');
                emails.forEach(email => {
                    response.value = email;
                    const re = /^[a-zA-Z0-9-._]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    if (re.test(email) === false) {
                        response.hasError = true;
                        response.errorMessage = 'Formato de correo no valido' || errorMessage;
                        return response;
                    }
                    return null;
                });
            }
            return response;
        };
    },
    domainUser: function domainUserValidator(errorMessage) {
        return function domainUserValidator(formValue) {
            const response = new ValidationResult('validator.domainUser');
            if (formValue.trim().length > 0) {
                response.value = formValue;
                const re = /^[A-Za-z0-9\\\._-]{7,}$/;
                if (re.test(formValue) === false) {
                    response.hasError = true;
                    response.errorMessage = 'Formato de usuario de dominio no valido' || errorMessage;
                }
            }
            return response;
        };
    },
    name: function nameValidator(errorMessage) {
        return function nameValidator(formValue) {
            const response = new ValidationResult('validator.name');
            if (!isNullOrEmpty(formValue)) {
                response.value = formValue;
                const re = /[^!°|"#$%&/()=?'¿¡\[\]+*¨{}:,;@0123456789]/;
                if (re.test(formValue) === false) {
                    response.hasError = true;
                    response.errorMessage = 'Formato no válido, no debe contener caracteres especiales' || errorMessage;
                }
            }
            return response;
        };
    },
    identity: function identityValidator(errorMessage) {
        return function identityValidator(formValue) {
            const response = new ValidationResult('validator.identity');
            if (!isNullOrEmpty(formValue)) {
                response.value = formValue;
                const re = /^[0-9]+$/;
                if (re.test(formValue) === false) {
                    response.hasError = true;
                    response.errorMessage = 'Formato no válido, no debe contener caracteres' || errorMessage;
                }
            }
            return response;
        };
    },
};
export function validateProperty(propertyValue, validations) {
    let result = new ValidationResult();
    if (validations == null) {
        return result;
    }
    for (var i = 0; i < validations.length; i++) {
        var validation = validations[i];
        if (typeof (validation) != 'function') {
            throw new Error('El validador debe ser una función');
        }
        else {
            var tmp = validation(propertyValue);
            if (tmp.hasError === true) {
                result = tmp;
                break;
            }
        }
    }
    return result;
}
export function validateObject(model, validations, output) {
    let isValid = true;
    let key;
    let errors = {};
    for (key in validations) {
        const value = model[key];
        const rules = validations[key];
        if (rules != null && rules.length > 0) {
            let validationResult = validateProperty(value, rules);
            if (validationResult.hasError) {
                isValid = false;
                errors[key] = validationResult.errorMessage;
            }
            else {
                errors[key] = '';
            }
        }
    }
    output(errors, isValid);
    return isValid;
}
export function validateDateValueValidator(valueIni, valueEnd) {
    let expectedValue = 0;
    if (valueIni != null && valueEnd != null) {
        if (valueIni < valueEnd) {
            expectedValue = -1;
        }
        else if (valueIni.getDate() === valueEnd.getDate()) {
            expectedValue = 0;
        }
        else {
            expectedValue = 1;
        }
    }
    return expectedValue;
}
